import { CARD_HEIGHT, CARD_WIDTH, APP_WIDTH, RESOLUTION } from '../utils/commonUtils';
import CardContainer from './cardContainer';
import GameFieldContainer from './gameFieldContainer';
import HandContainer from './handContainer';
import MainDeckContainer from './mainDeckContainer';
import CharacterAreaContainer from './characterAreaContainer';
import DonsContainer from './donsContainer';
import LeaderContainer from './leaderContainer';
import StageContainer from './stageContainer';
import TrashContainer from './trashContainer';

const LEADER_POSITION = {
    x: -13*RESOLUTION,
    y: 598*RESOLUTION,
};

const MAIN_DECK_POSITION = {
    x: -448*RESOLUTION,
    y: 566*RESOLUTION,
};

const CHARACTER_AREA_POSITION = {
    x: 0,
    y: 910*RESOLUTION,
};

const DONS_POSITION = {
    x: 478*RESOLUTION,
    y: 522*RESOLUTION,
};

const STAGE_POSITION = {
    x: -288*RESOLUTION,
    y: 464*RESOLUTION,
};

const TRASH_POSITION = {
    x: -288*RESOLUTION,
    y: 571*RESOLUTION,
};

const opponentLeaderContainerLabel = 'opponentLeaderContainer';
const opponentHandContainerLabel = 'opponentHandContainer';
const opponentMainDeckContainerLabel = 'opponentMainDeckContainer';
const opponentCharacterAreaContainerLabel = 'opponentCharacterAreaContainer';
const opponentDonsContainerLabel = 'opponentDonsContainer';
const opponentStageContainerLabel = 'opponentStageContainer';
const opponentTrashContainerLabel = 'opponentTrashContainer';

export default class OpponentContainer extends GameFieldContainer {
    constructor(opponentState, onCardTapped, onCardReleased, onCardHeld) {
        super('opponent', onCardTapped, onCardReleased, onCardHeld);
        this.createLeaderCard(opponentState);
        this.createMainDeckContainer(opponentState);
        this.createCharacterAreaContainer();
        this.createDonsContainer(opponentState);
        this.createStageContainer();
        this.createTrashContainer();
        this.createHandContainer(opponentState);
    }

    createLeaderCard(opponentState) {
        const opponentLeaderContainer = new LeaderContainer(opponentState, true);
        opponentLeaderContainer.label = opponentLeaderContainerLabel;
        opponentLeaderContainer.x = LEADER_POSITION.x;
        opponentLeaderContainer.y = LEADER_POSITION.y;
        this.addChild(opponentLeaderContainer)
    }

    createHandContainer(opponentState) {
        const opponentHandContainer = new HandContainer(opponentState.handCount, opponentState.hand);
        opponentHandContainer.label = opponentHandContainerLabel;
        opponentHandContainer.x = 0;
        opponentHandContainer.y = 0;
        opponentHandContainer.angle = 180;
        this.addChild(opponentHandContainer)
    }

    createMainDeckContainer(opponentState) {
        const opponentMainDeckContainer = new MainDeckContainer(opponentState.deckCount, true);
        opponentMainDeckContainer.label = opponentMainDeckContainerLabel;
        opponentMainDeckContainer.x = MAIN_DECK_POSITION.x;
        opponentMainDeckContainer.y = MAIN_DECK_POSITION.y;
        this.addChild(opponentMainDeckContainer);
    }

    createCharacterAreaContainer() {
        const opponentCharacterAreaContainer = new CharacterAreaContainer();
        opponentCharacterAreaContainer.label = opponentCharacterAreaContainerLabel;
        opponentCharacterAreaContainer.x = CHARACTER_AREA_POSITION.x;
        opponentCharacterAreaContainer.y = CHARACTER_AREA_POSITION.y;
        this.addChild(opponentCharacterAreaContainer);
    }

    createDonsContainer(opponentState) {
        const opponentDonsContainer = new DonsContainer(opponentState, true);
        opponentDonsContainer.label = opponentDonsContainerLabel;
        opponentDonsContainer.x = DONS_POSITION.x;
        opponentDonsContainer.y = DONS_POSITION.y;
        this.addChild(opponentDonsContainer);
    }

    createStageContainer() {
        const opponentStageContainer = new StageContainer();
        opponentStageContainer.label = opponentStageContainerLabel;
        opponentStageContainer.x = STAGE_POSITION.x;
        opponentStageContainer.y = STAGE_POSITION.y;
        this.addChild(opponentStageContainer);
    }

    createTrashContainer() {
        const opponentTrashContainer = new TrashContainer(false);
        opponentTrashContainer.label = opponentTrashContainerLabel;
        opponentTrashContainer.x = TRASH_POSITION.x;
        opponentTrashContainer.y = TRASH_POSITION.y;
        this.addChild(opponentTrashContainer);
    }

    updateLeader(opponentState, clientGameState) {
        this.getChildByLabel(opponentLeaderContainerLabel).update(opponentState, clientGameState);
    }

    updateHand(gameState, opponentState, clientGameState) {
        this.getChildByLabel(opponentHandContainerLabel).updateHand(gameState, opponentState, clientGameState);
    }

    updateMainDeck(deckCount) {
        this.getChildByLabel(opponentMainDeckContainerLabel).updateText(deckCount.toString());
    }

    updateCharacterArea(characterArea, clientGameState) {
        this.getChildByLabel(opponentCharacterAreaContainerLabel).updateCharacterArea(characterArea, clientGameState);
    }

    updateDonsContainer(opponentState, clientGameState) {
        this.getChildByLabel(opponentDonsContainerLabel).update(opponentState, clientGameState);
    }

    updateStageContainer(opponentState) {
        this.getChildByLabel(opponentStageContainerLabel).update(opponentState);
    }

    updateTrashContainer(opponentState) {
        this.getChildByLabel(opponentTrashContainerLabel).update(opponentState);
    }
}
